<script>
export default {
  props: {
    modelValue: Boolean,
    getQuestionNumber: Function,
    soalStats: Object,
    listItem: Array,
    index_soal: Number,
  },
  emits: ['update:modelValue'],
};
</script>

<template>
  <b-modal
    :model-value="modelValue"
    @hide="$emit('update:modelValue', false)"
    centered
    hide-footer
    title="Progress Pengerjaan"
    modal-class="mym-modal-wrapper"
  >
    <!-- SUBTITLE -->
    <div class="mym-subtitle">
      {{ soalStats?.answered }} dari {{ soalStats?.total }} soal terjawab
    </div>

    <!-- SUMMARY -->
    <div class="mym-summary">
      <div class="mym-summary-item mym-answered">
        ✔ Terjawab: {{ soalStats?.answered }}
      </div>
      <div class="mym-summary-item mym-unanswered">
        ○ Belum: {{ soalStats?.unanswered }}
      </div>
    </div>

    <!-- GRID -->
    <div class="mym-progress-grid">
      <div
        v-for="(q, i) in listItem"
        :key="i"
        class="mym-progress-box"
        :class="{
          'mym-answered-box': q.jawaban_peserta !== null,
          'mym-active-box': index_soal === i && q.tipe !== 'Menjodohkan',
          'mym-instruction-box mym-full-row': q.is_instruksi === 1,
        }"
      >
        <span v-if="q.is_instruksi === 1">
          <i class="fa fa-info-circle me-1"></i>
          {{ "Instruksi " + q.tipe }}
        </span>
        <span v-else>
          {{ getQuestionNumber(i) }}
        </span>
      </div>
    </div>

    <!-- FOOTER BUTTON -->
    <div class="mt-4">
      <button
        type="button"
        class="mym-btn-close"
        @click="$emit('update:modelValue', false)"
      >
        Tutup
      </button>
    </div>
  </b-modal>
</template>